import type {AuthProvider} from "@refinedev/core";
import {adminLogin, adminLogout, getAdminSession} from "@zaaaz/shared";

export const adminAuthProvider: AuthProvider = {
  login: async ({email, password}) => {
    const session = await adminLogin(String(email), String(password));
    if(!session.authenticated) {
      return {success: false, error: {name: "LoginError", message: "Authentication failed"}};
    }
    return {success: true, redirectTo: "/vadmin"};
  },
  logout: async () => {
    await adminLogout();
    return {success: true, redirectTo: "/vadmin/login"};
  },
  check: async () => {
    try {
      const session = await getAdminSession();
      if(session.authenticated) return {authenticated: true};
      return {authenticated: false, redirectTo: "/vadmin/login", logout: true};
    } catch {
      return {authenticated: false, redirectTo: "/vadmin/login", logout: true};
    }
  },
  getIdentity: async () => {
    const session = await getAdminSession();
    if(!session.authenticated || !session.id) return null;
    return {id: session.id, name: session.nume, email: session.email, rol: session.rol};
  },
  onError: async (error) => {
    if(error?.statusCode === 401 || error?.statusCode === 403) {
      return {logout: true, redirectTo: "/vadmin/login"};
    }
    return {error};
  }
};
